import { acceptObjectValue } from '../../field-viewer/shared-normalizers';
export const ecomFullNameViewer = {
    normalizeLoadedValue: acceptObjectValue
};

//# sourceMappingURL=definition-viewer.js.map